import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SwalService } from '@shared/utils/swal.service';
import { Table } from 'primeng/table';
import { UserService } from '@pages/user/services/user.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-user-niveles',
  templateUrl: './user-niveles.component.html'
})
export class UserNivelesComponent implements OnInit {
  @ViewChild('dt') table: Table;
  @Input() usuarioData: any;

  loading: boolean = false;
  dataSource: any[] = [];
  searchTerm: string = '';
  
  // Opciones para dropdowns
  tiposCreditoOptions: any[] = [];
  
  // Propiedades para el diálogo de formulario
  displayDialog: boolean = false;
  formTitle: string = 'Nuevo Nivel';
  nivelForm: FormGroup;
  modoEdicion: boolean = false;
  nivelSeleccionado: any = null;

  columns: any[] = [
    { field: 'tipo_Credito', header: 'Tipo de Crédito' },
    { field: 'descTipoCredito', header: 'Descripción' },
    { field: 'linea_autorizacion', header: 'Línea de Autorización' },
    { field: 's_min_prescoring', header: 'Min. Prescoring' },
    { field: 's_min_scoring', header: 'Min. Scoring' },
    { field: 'actions', header: 'Acciones' }
  ];

  constructor(
    private fb: FormBuilder,
    private _swalService: SwalService,
    private _userService: UserService
  ) {
    this.initForm();
  }

  private initForm(): void {
    this.nivelForm = this.fb.group({
      clave_usuario: [{value: '', disabled: true}],
      tipo_Credito: [''],
      linea_autorizacion: [0],
      s_min_scoring: [0],
      s_min_prescoring: [0],
      vigenciaDias: [0],
      firmasArriba: [0],
      limiteLinea: [0],
      firmas: [0],
      arribaVigenciaDias: [0],
      mancomunada: [false],
      mancArriba: [false]
    });
  }

  ngOnInit(): void {
    this.cargarTiposCredito();
    this.cargarNiveles();
  }

  cargarTiposCredito(): void {
    this._userService.getTiposCredito().subscribe({
      next: (response) => {
        if (response.success && response.data) {
          // Mapear los datos para el dropdown: producto | descripcion
          this.tiposCreditoOptions = response.data.map((item: any) => ({
            label: `${item.producto} | ${item.descripcion}`,
            value: item.producto // Usar producto como clave, no tipo_Credito
          }));
        } else {
          this.tiposCreditoOptions = [];
        }
      },
      error: (error) => {
        console.error('Error al cargar tipos de crédito:', error);
        this.tiposCreditoOptions = [];
      }
    });
  }

  cargarNiveles(): void {
    this.loading = true;
    
    // Obtener la clave del usuario desde el componente padre
    const claveUsuario = this.getClaveUsuario();
    
    // Si no hay clave de usuario, no hacer la llamada al API
    if (!claveUsuario) {
      this.dataSource = [];
      this.loading = false;
      return;
    }
    
    this._userService.getNivelesUsuario("9999", claveUsuario).subscribe({
      next: (response) => {
        // Verificar si hay datos, independientemente del valor de success
        if (response.data && response.data.length > 0) {
          this.dataSource = response.data;
        } else {
          // Si no hay datos, simplemente mostrar tabla vacía sin error
          this.dataSource = [];
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar niveles:', error);
        this._swalService.error('Error al cargar los niveles');
        this.dataSource = [];
        this.loading = false;
      }
    });
  }

  getClaveUsuario(): string {
    // Obtener la clave del usuario desde el componente padre
    if (this.usuarioData && this.usuarioData.userName) {
      // Limpiar espacios en blanco al inicio y final del userName
      return this.usuarioData.userName.trim();
    }
    return ""; 
  }

  filtrarNiveles(): void {
    // Implementar lógica de filtrado
    console.log('Filtrando por:', this.searchTerm);
  }

  nuevo(): void {
    this.modoEdicion = false;
    this.nivelSeleccionado = null;
    this.formTitle = 'Nuevo Nivel';
    
    // Establecer la clave del usuario
    const claveUsuario = this.getClaveUsuario();
    
    this.nivelForm.reset({
      clave_usuario: claveUsuario,
      linea_autorizacion: 0,
      s_min_scoring: 0,
      s_min_prescoring: 0,
      vigenciaDias: 0,
      firmasArriba: 0,
      limiteLinea: 0,
      firmas: 0,
      arribaVigenciaDias: 0,
      mancomunada: false,
      mancArriba: false
    });
    this.displayDialog = true;
  }

  editar(nivel: any): void {
    this.modoEdicion = true;
    this.nivelSeleccionado = nivel;
    this.formTitle = 'Editar Nivel';
    
    // Establecer la clave del usuario
    const claveUsuario = this.getClaveUsuario();
    
    this.nivelForm.patchValue({
      clave_usuario: claveUsuario,
      tipo_Credito: nivel.tipo_Credito,
      linea_autorizacion: nivel.linea_autorizacion,
      s_min_scoring: nivel.s_min_scoring,
      s_min_prescoring: nivel.s_min_prescoring,
      vigenciaDias: nivel.vigenciaDias,
      firmasArriba: nivel.firmasArriba,
      limiteLinea: nivel.limiteLinea,
      firmas: nivel.firmas,
      arribaVigenciaDias: nivel.arribaVigenciaDias,
      mancomunada: nivel.mancomunada,
      mancArriba: nivel.mancArriba
    });
    this.displayDialog = true;
  }

  eliminar(nivel: any): void {
    Swal.fire({
      title: '¿Está seguro?',
      text: '¿Desea eliminar este nivel?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      iconColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        
        // Preparar el payload para eliminar: solo clave_usuario y tipo_credito
        const payload = {
          que: 3, // 3 para eliminar
          clave_usuario: this.getClaveUsuario(),
          tipo_credito: nivel.tipo_Credito,
          linea_autorizacion: 0,
          s_min_prescoring: 0,
          s_min_scoring: 0,
          limiteLinea: 0,
          mancomunada: "0",
          firmas: 0,
          vigenciaDias: 0,
          mancArriba: "0",
          firmasArriba: 0,
          arribaVigenciaDias: 0
        };

        this._userService.guardarNivelUsuario(payload).subscribe({
          next: (response) => {
            this.loading = false;
            
            // Verificar si se eliminó correctamente
            const isSuccess = (response.success === false && response.data && response.data[0] && response.data[0].error === '0') || 
                             (response.success === true);
            
            if (isSuccess) {
              this._swalService.success('Nivel eliminado correctamente');
              this.cargarNiveles();
            } else {
              const errorMessage = response.data && response.data[0] ? response.data[0].error : 'Error al eliminar el nivel';
              this._swalService.error(errorMessage);
            }
          },
          error: (error) => {
            this.loading = false;
            console.error('Error al eliminar nivel:', error);
            this._swalService.error('Error al eliminar el nivel');
          }
        });
      }
    });
  }

  guardarNivel(): void {
    if (this.nivelForm.invalid) {
      this._swalService.error('Por favor complete todos los campos requeridos');
      return;
    }

    const formData = this.nivelForm.getRawValue(); // Para obtener valores de campos deshabilitados
    this.loading = true;

    // Preparar el payload según la especificación del API
    const payload = {
      que: this.modoEdicion ? 2 : 1, // 1 para crear, 2 para editar
      clave_usuario: formData.clave_usuario,
      tipo_credito: formData.tipo_Credito,
      linea_autorizacion: formData.linea_autorizacion || 0,
      s_min_prescoring: formData.s_min_prescoring || 0,
      s_min_scoring: formData.s_min_scoring || 0,
      limiteLinea: formData.limiteLinea || 0,
      mancomunada: formData.mancomunada ? "1" : "0",
      firmas: formData.firmas || 0,
      vigenciaDias: formData.vigenciaDias || 0,
      mancArriba: formData.mancArriba ? "1" : "0",
      firmasArriba: formData.firmasArriba || 0,
      arribaVigenciaDias: formData.arribaVigenciaDias || 0
    };

    this._userService.guardarNivelUsuario(payload).subscribe({
      next: (response) => {
        this.loading = false;
        
        // Verificar si se guardó correctamente
        // Si error = '0' y success = false, significa que se guardó correctamente
        const isSuccess = (response.success === false && response.data && response.data[0] && response.data[0].error === '0') || 
                         (response.success === true);
        
        if (isSuccess) {
          this._swalService.success(
            this.modoEdicion ? 'Nivel actualizado correctamente' : 'Nivel guardado correctamente'
          );
          this.displayDialog = false;
          this.nivelForm.reset();
          this.cargarNiveles();
        } else {
          const errorMessage = response.data && response.data[0] ? response.data[0].error : 'Error al guardar el nivel';
          this._swalService.error(errorMessage);
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('Error al guardar nivel:', error);
        this._swalService.error('Error al guardar el nivel');
      }
    });
  }

  hideDialog(): void {
    this.displayDialog = false;
    this.nivelForm.reset();
  }
} 